<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            /
            <router-link :to="{name: 'admin-master' }" class="root">
                Admin Master
            </router-link>
            <span class="child">/ Course Authority Operations </span>
        </v-row>
        <!-- <br /> -->
        <!-- <center class="heading">
        <h3>Course Authority Operations</h3>
    </center> -->
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>Course Authority Operations</span>
            </v-card-title>
            <v-card-text>
                <template>
                    <v-data-table :headers="headers" :items="authoritylist" :search="search" class="elevation-1 nowrap">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                                <span style="width: 20px;"></span>
                                <template>
                                    <v-btn class="button" @click="dialog_add=true">Add Course Authority Operation</v-btn>
                                </template>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.isactive="{ item }">
                            <v-icon v-if="item.isactive==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                            <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-switch v-model="item.isactive" color="rgb(1, 127, 152)" @change="editItem(item)"></v-switch>

                            <!-- <v-btn icon @click="deleteOperation(item)" color="error"> <v-icon>mdi-delete</v-icon></v-btn> -->

                            <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link"  color="info"> <v-icon  title="Activate/Deactivate the Mode" >mdi-recycle</v-icon></v-btn> -->
                        </template>
                        <template v-slot:item.actions1="{ item }">
                            <v-btn icon @click="deletedialog(item)" color="error"> <v-icon>mdi-delete-circle</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </template>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog_delete" persistent max-width="400px">
            <v-card>
                <v-container>
                    <h3><strong>Are you sure you want Delete this Course Authority Operation???</strong></h3>
                    <v-row justify="center">
                        <v-btn class="button-cancel mr-2" @click="dialog_delete = false">No</v-btn>
                        <v-btn class="button" @click="deleteOperation(item)">Yes</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-row justify="center">
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-dialog v-model="dialog_add" persistent max-width="600px">
                    <v-card>
                        <v-card-title class="heading">
                            <span class="headline">Add New Course Authority Operation</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            :items="authority_super"
                                            label="Select course authority operation"
                                            required
                                            item-value="id"
                                            item-text="name"
                                            v-model="course_authority"
                                            :hint="course_authority != ''? '':'Please Select Course Authority Operation'"
                                            persistent-hint
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <small>*indicates required field</small>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button-cancel" text @click="close">Close</v-btn>
                            <v-btn class="button" text @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            search: "",
            snackbar_msg: "",
            snackbar: false,
            edit_btn_load: false,
            color: "",
            authoritylist: [],
            course_authority: "",
            authority_super: [],
            org: null,
            dialog_delete: false,
            dialog_add: false,
            valid: false,
            delete_id: null,
            headers: [
                { text: "Name", value: "name" },
                { text: "Activate", value: "isactive" },
                { text: "Actions", value: "actions", sortable: false },
                { text: "Delete", value: "actions1", sortable: false },
            ],
        }),
        watch: {
            config() {
                // this.config_value = null;
            },
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                console.log(item);
                //alert(item)
                this.edit_btn_load = true;
                const data = {
                    id: item.id,
                };
                axios
                    .post("/adminMaster/editCourseAuthorityOperation", data)
                    .then((res) => {
                        this.authoritylist = res.data.authoritylist;
                        this.showSnackbar("#4CAF50", "Course Authority status updated successfully...");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.edit_btn_load = false;
                        axios;
                    });
            },
            save() {
                //alert("in save"+this.course_authority)
                if (this.course_authority == "") {
                    this.showSnackbar("#b71c1c", "Please select Course Authority Operation!!!");
                } else {
                    const data = {
                        id: this.course_authority,
                    };
                    axios
                        .post("/adminMaster/saveCourseAuthorityOperation", data)
                        .then((res) => {
                            this.dialog_add = false;
                            if (res.data.status == "YES") {
                                this.showSnackbar("#4CAF50", "Course Authority status added successfully...");
                                //this.showSnackbar("#4CAF50","Course Authority status added successfully...")
                            } else if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", "Course Authority status already present!!!");
                            }

                            this.onLoad();
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {
                            this.course_authority = "";
                        });
                }
            },
            close() {
                this.dialog_add = false;
                this.course_authority = "";
            },
            onLoad() {
                axios
                    .post("/adminMaster/courseAuthorityOperation")
                    .then((res) => {
                        this.authoritylist = res.data.authoritylist;
                        this.authority_super = res.data.authority_super;
                        this.org = res.data.organization;
                        this.level = res.data.level;
                        //this.showSnackbar("#4CAF50","Success")
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            deletedialog(item) {
                //alert(item)
                this.dialog_delete = true;
                this.delete_id = item.id;
            },
            deleteOperation() {
                //alert("delete")
                let formData = new FormData();
                formData.append("id", this.delete_id);
                axios
                    .post("/adminMaster/deleteCourseAuthorityOperation", formData)
                    .then((res) => {
                        if (res.data.ststus == "YES") {
                            this.showSnackbar("#4CAF50", "Course Authority Operation deleted successfully...");
                            this.dialog_delete = false;
                            this.onLoad();
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("error", "You can not delete this operation!!!");
                            this.dialog_delete = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.dialog_delete = false;
                    });
            },
        },
        mounted() {
            this.onLoad();
        },
    };
</script>
